<div style="padding: 10px" [innerHTML] = "message | keepHtml">
</div>
<div class="spinner-container">
  @if (isIndefinite()) {
    <p-progressSpinner>
    </p-progressSpinner>
  }
  @if (!isIndefinite()) {
    <div class="width100p">
      <p-progressBar [value]="progress" [showValue]=false></p-progressBar>
      {{progressStatus}}
    </div>
  }
</div>
